export function parseTabelDataExportFormat(heading: string[], arrayToExport: any[][], specie: domains.domini[], tabella: tabellaDiRiepilogo, prefix: string = "") {
    specie.push({ 
      id: -1,
      _ts: -1,
      value: "Totale",
      label: "Totale",
    })
    for (var j = 0; j < specie.length; j++) {
      heading.push(specie[j].value);
      const pianteAdEttaro = tabella.pianteAdEttaro.filter(v => v.value && v.specie == specie[j].value);
      const areaBasimetricaAdEttaro = tabella.areaBasimetricaAdEttaro.filter(v => v.value && v.specie == specie[j].value);
      const diametroMedio = tabella.diametroMedio.filter(v => v.value && v.specie == specie[j].value);
      const altezzaMedia = tabella.altezzaMedia.filter(v => v.value && v.specie == specie[j].value);
      const volumeAdEttaro = tabella.volumeAdEttaro.filter(v => v.value && v.specie == specie[j].value);

      const pianteAdEttaroValue = pianteAdEttaro !== null && pianteAdEttaro.length > 0 ? pianteAdEttaro.reduce(v => v)?.value : null;
      const areaBasimetricaAdEttaroValue = areaBasimetricaAdEttaro !== null && areaBasimetricaAdEttaro.length > 0 ? areaBasimetricaAdEttaro.reduce(v => v)?.value : null;
      const diametroMedioValue = diametroMedio !== null && diametroMedio.length > 0 ? diametroMedio.reduce(v => v)?.value : null;
      const altezzaMediaValue = altezzaMedia !== null && altezzaMedia.length > 0 ? altezzaMedia.reduce(v => v)?.value : null;
      const volumeAdEttaroValue = volumeAdEttaro !== null && volumeAdEttaro.length > 0 ? volumeAdEttaro.reduce(v => v)?.value : null;
      arrayToExport[0][specie[j].value + prefix] = !pianteAdEttaroValue ? null : pianteAdEttaroValue.toFixed(0);
      arrayToExport[1][specie[j].value + prefix] = !areaBasimetricaAdEttaroValue ? null : areaBasimetricaAdEttaroValue.toFixed(2);
      arrayToExport[2][specie[j].value + prefix] = !diametroMedioValue ? null : diametroMedioValue.toFixed(0);
      arrayToExport[3][specie[j].value + prefix] = !altezzaMediaValue ? null : altezzaMediaValue.toFixed(1);
      arrayToExport[4][specie[j].value + prefix] = !volumeAdEttaroValue ? null : volumeAdEttaroValue.toFixed(3);
    }
  }